import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { BehaviorSubject } from 'rxjs';
import AppLauncherElectron from 'src/app/plugins/app-launcher.plugin';
import { isElectron } from 'src/app/shared/utils/platform.utils';

@Component({
    selector: 'agree-privacy',
    templateUrl: './agree-privacy.component.html',
    styleUrls: ['./agree-privacy.component.scss'],
    standalone: false
})
export class AgreePrivacyComponent implements OnInit {
    type = new BehaviorSubject<'PP' | 'TOS'>("PP");
    checkboxValue = new BehaviorSubject(false);

    constructor(
        private matDialogRef: MatDialogRef<AgreePrivacyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: 'PP' | 'TOS',
        private iab: InAppBrowser,
    ) { }

    ngOnInit() {
        this.type.next(this.data);
    }

    cancel(){
        this.matDialogRef.close(false);
    }

    confirm(){
        if(!this.checkboxValue.value) return;
        this.matDialogRef.close(true);
    }

    openAppBrowser(url: string):void {
        if (isElectron()) AppLauncherElectron.openUrl({ url });
        else this.iab.create(url, '_system');
    }

    checkbox() {
        this.checkboxValue.next(!this.checkboxValue.value);
    }
}
